import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';
import { Provider } from 'react-redux';

import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import OrderContext from './context/orderContext'
import configureStore from './store/configureStore';

const browserHistory = createBrowserHistory();
const store = configureStore();



Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export default class App extends Component {
  handleChangeActionType = ({actionType, ticketId=null}) => {
    this.setState({ actionType, ticketId  });
  };

  state = { actionType: null, ticketId: null };

  render() {
    return (
      <Provider store={store}>
      <OrderContext.Provider
      value={{
        actionType: this.state.actionType,
        ticketId: this.state.ticketId,
        changeActionType: this.handleChangeActionType
      }}
    >
        <ThemeProvider theme={theme}>
          <Router history={browserHistory}>
            <Routes />
          </Router>
        </ThemeProvider>
      </OrderContext.Provider>
      </Provider>
    );
  }
}
